import script from "./AllMediaPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AllMediaPage.vue?vue&type=script&setup=true&lang=js"

import "./AllMediaPage.vue?vue&type=style&index=0&id=02253d80&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02253d80"]])

export default __exports__